export default "__VITE_ASSET__BtH46fzS__"